import axios from "axios";
import React from "react";
import "react-toastify/dist/ReactToastify.css";
import { PaginationLinks } from "./helper";

class MemberPayOrNotList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      primary_member_status: null,
      sidebarOpen: false,
      setSidebarOpen: false,
      showmsg: false,
      redirect: false,
      deleteRedirect: false,
      logoutRedirect: false,
      invoices_member: [],
      order_id_from_server: "",
      invoice_id: "",
      cryptKey: "",
      links: [],
      Minidash: [],
      MinidashTwo: [],
      totalnoof: "",
      perpage: "",
      from: "",
      to: "",
      loader: "",
      overLay: "",
      payment_success: false,
      customerIdCrypt: this.props.customerIdCrypt,
    };
  }

  setLoaderFunction = () => {
    this.props.setLoaderFunction(true, true);
  };

  closeLoaderFuncion = () => {
    this.props.closeLoaderFuncion();
  };

  componentDidMount() {
    const token = localStorage.getItem("token");
    this.setLoaderFunction();
    axios
      .get("api/invoice/pagination/member/m/" + this.state.customerIdCrypt, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        const invoices1 = res.data.invoices_member.data;
        this.state.primary_member_status = res.data.memberDetail;
        let link = res.data.invoices_member.links;

        this.setState({ invoices_member: invoices1 });
        this.setState({ loader: "" });
        this.setState({ links: link });
        this.setState({ perpage: res.data.invoices_member.per_page });
        this.setState({ totalnoof: res.data.invoices_member.total });
        this.setState({ from: res.data.invoices_member.from });
        this.setState({ to: res.data.invoices_member.to });
        this.closeLoaderFuncion();
      });

    axios
      .get("api/member/dashboard/m/" + this.state.customerIdCrypt, {
        headers: {
          authorization: `Bearer ${token}`,
          Accept: "application/json",
        },
      })
      .then((res) => {
        this.setState({ Minidash: res.data.one });
        this.setState({ MinidashTwo: res.data.three });
      });
  }

  paginationFetch = async (e) => {
    if (e) {
      this.setLoaderFunction();
      this.state.invoices_member = [];

      const token = localStorage.getItem("token");
      const res = axios
        .get(e, {
          headers: {
            authorization: `Bearer ${token}`,
            Accept: "application/json",
          },
        })
        .then((res) => {
          const invoices_member = res.data.invoices_member.data;
          let link = res.data.invoices_member.links;
          this.setState({ invoices_member: invoices_member });
          this.setState({ loader: "" });
          this.setState({ links: link });
          this.setState({ perpage: res.data.invoices_member.per_page });
          this.setState({ totalnoof: res.data.invoices_member.total });
          this.setState({ from: res.data.invoices_member.from });
          this.setState({ to: res.data.invoices_member.to });
          this.closeLoaderFuncion();
        });
    }
  };

  render() {
    return (
      <>
        <div>
          <div className="flex flex-col flex-1">
            <main className="flex-1">
              <div className="py-6">
                <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8">
                  <div>
                    <h3 className="text-lg leading-6 font-medium text-gray-900">
                      Transaction details
                    </h3>
                    <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                      {this.state.Minidash.map((item) => (
                        <div key={item.id} className="px-4 py-5 sm:p-6">
                          <dt className="text-base font-normal text-gray-900">
                            {item.name}
                          </dt>
                          <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                            <div className="flex items-baseline text-2xl font-semibold text-indigo-600">
                              {item.stat}
                            </div>
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </div>
                  <div>
                    <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
                      {this.state.MinidashTwo.map((item) => (
                        <div key={item.id} className="px-4 py-5 sm:p-6">
                          <dt className="text-base font-normal text-gray-900">
                            {item.name}
                          </dt>
                          <dd className="mt-1 flex justify-between items-baseline md:block lg:flex">
                            <div className="flex items-baseline text-2xl font-semibold text-indigo-600">
                              {item.stat}
                            </div>
                          </dd>
                        </div>
                      ))}
                    </dl>
                  </div>

                  {/* Replace with your content */}
                  <div className="px-4 sm:px-6 lg:px-8 mt-6">
                    <div className="sm:flex sm:items-center">
                      <div className="sm:flex-auto">
                        <h1 className="text-xl font-semibold text-gray-900">
                          Dues List
                        </h1>
                        <p className="mt-2 text-sm text-gray-700">
                          A list of all the dues
                        </p>
                      </div>
                    </div>
                    <div className="mt-8 flex flex-col">
                      <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                        <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                          <div className="overflow-hidden shadow ring-1 ring-black ring-opacity-5 md:rounded-lg">
                            <table
                              className={`min-w-full divide-y divide-gray-300 ${this.state.loader}`}
                            >
                              <thead className="bg-gray-50">
                                <tr>
                                  <th
                                    scope="col"
                                    className="py-3 pl-4 pr-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500 sm:pl-6"
                                  >
                                    Date
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Due#
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    House Number
                                  </th>

                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Member Name
                                  </th>

                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Amount
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Status
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-left text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Balance Due
                                  </th>
                                  <th
                                    scope="col"
                                    className="px-3 py-3 text-center text-xs font-medium uppercase tracking-wide text-gray-500"
                                  >
                                    Action
                                  </th>
                                </tr>
                              </thead>
                              <tbody className="divide-y divide-gray-200 bg-white">
                                {this.state.invoices_member.map((person) => (
                                  <tr key={person.id}>
                                    <td className="whitespace-nowrap py-4 pl-4 pr-3 text-sm font-medium text-gray-900 sm:pl-6">
                                      {person.invoice_date}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_number}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_house.house_number}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {
                                        person.primary_member
                                          ?.primary_contact_first_name
                                      }{" "}
                                      {
                                        person.primary_member
                                          ?.primary_contact_last_name
                                      }
                                    </td>

                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_total}
                                    </td>

                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_state?.name}
                                    </td>
                                    <td className="whitespace-nowrap px-3 py-4 text-sm text-gray-500">
                                      {person.invoice_balance_due}
                                    </td>

                                    <td className="relative whitespace-nowrap py-4 pl-3 pr-4 text-right text-sm font-medium sm:pr-6">
                                      {person.invoice_state_id != 2 ? (
                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-red-100 text-green-800 cursor-pointer">
                                          Not Paid
                                        </span>
                                      ) : (
                                        <span className="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-green-100 text-green-800 cursor-pointer">
                                          Paid
                                        </span>
                                      )}
                                    </td>
                                  </tr>
                                ))}
                              </tbody>
                            </table>
                            {/*pagination*/}

                            {/*part_three_pagination_links----------------------------------------------------------------------------------------------*/}
                            <PaginationLinks
                              from={this.state.from}
                              to={this.state.to}
                              total_no_of_item={this.state.total_no_of_project}
                              links={this.state.links}
                              loader={this.setLoaderFunction}
                              paginationFetch={this.paginationFetch}
                            />
                            {/*part_three_pagination_links----------------------------------------------------------------------------------------------*/}

                            {/*pagination*/}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* /End replace */}
                </div>
              </div>
            </main>
          </div>
        </div>
      </>
    );
  }
}

export default MemberPayOrNotList;
